import { useCallback } from 'react';
import { usePrinterContext, browserPrintOrder } from '../context/PrinterContext';
import { useToast } from '../components/common/ToastProvider';

// Prints a bill-shaped receipt (mapOrderToReceipt / mapGiftVoucherSaleToReceipt)
// the way the normal checkout does: through the printer app when it is
// connected, otherwise (or if it fails) through the browser print dialog.
export function useThermalReceiptPrint() {
  const showToast = useToast();
  const { isConnected, status, silentPrintOrder } = usePrinterContext();

  const printReceipt = useCallback(async (receipt) => {
    if (!receipt) return;
    if (isConnected) {
      try {
        await silentPrintOrder(receipt);
        showToast('Receipt printed', 'success');
        return;
      } catch (err) {
        console.error('[Printer] silentPrintOrder failed:', err);
        showToast('Printer error — switching to browser print', 'warning');
      }
    } else {
      showToast('Printer app not connected — printing via browser', 'info');
    }
    // Let the toast show before the print dialog covers the screen.
    await new Promise((r) => setTimeout(r, 1500));
    browserPrintOrder(receipt);
  }, [isConnected, silentPrintOrder, showToast]);

  return { printReceipt, printerStatus: status };
}
